
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from 'react';
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import swal from "sweetalert";
import Select from 'react-select';
import { Modal, IconButton, Box, Tooltip, Backdrop, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import { useLocation } from "react-router-dom";

const SERVER_URL = process.env.REACT_APP_API_URL;

function EditRaiseWorkPlanDeviation() {
  const [planDetails, setPlanDetails] = useState({ date: '', day: '', plan: '' });
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedDate, setSelectedDate] = useState("");  // For the date input
  const [setLoad, setSetLoad] = useState(true); // For loading state
  const [isModalOpen, setModalOpen] = useState(false);
  const [searchISLoading, setSearchIsLoading] = useState(false)
  const [selectedDayIndex, setSelectedDayIndex] = useState(null);
  const [weekDays, setWeekDays] = useState([]);
  const [formData, setFormData] = useState({
    retailer_code: "",
    store_name: "",
    email: "",
    abn: "",
    state: "",
    city: "",
    postcode: "",
    street_name: "",
  });

  const location = useLocation();
  const { retailer_id, workPlanId } = location.state || {};

  console.log('1', location.state);


  useEffect(() => {
    // Function to fetch work plan data from API
    const fetchWorkPlanData = async () => {
      try {
        const headers = await getApiHeader(); // Get headers (like Authorization)
        const response = await axios.post(
          `${SERVER_URL}work-plan/get-my-work-plan-deviation-request-info`,
          {
            work_plan_deviation_id: workPlanId,
           
          },
          {
            headers: headers,
          }
        );

        if (response.status === 200) {
          const workPlanData = response.data.data.work_plan_deviation_info;
          const workPlan = workPlanData;

          const mappedWeekDays = [{
            date: workPlan.date,
            dayName: new Date(workPlan.date).toLocaleString('en-us', { weekday: 'long' }),
            selectedDays: workPlan.store_data.map(store => ({
              label: store.retailer_company_name,
              value: store.retailer_id,
            })),
            plan: workPlan.activity_notes,
            work_plan: workPlan.work_plan_deviation_id,
            manager_comment: workPlan.manager_comments,
          }];
          setManagerCommentes(workPlan.manager_comments)

          setWorkPlanData([workPlan]); // Wrap it in an array if it's a single object
          setWeekDays(mappedWeekDays); // Set the weekDays state with mapped data
          setStoreOptions(mappedWeekDays.map(day => day.selectedDays));
        }

        setSetLoad(false); // Hide loader after data is fetched
      } catch (error) {
        const errorMessage = error?.response?.data?.message;
        toast.error(errorMessage);
        setSetLoad(false);
      }
    };

    fetchWorkPlanData();
  }, [workPlanId, retailer_id]); // Adding dependencies to re-fetch data on WorkplanId or RetailerId change


  const handleModalToggle = (index) => {
    setSelectedDayIndex(index);
    setModalOpen(!isModalOpen);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle the selected day change
  const handleDayChange = (selectedOption) => {
    setSelectedDay(selectedOption);
  };

  // Handle the selected date change
  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);
    setPlanDetails({ ...planDetails, date: newDate });
  };

  // Options for day selection (Monday, Tuesday, etc.)
  const daysOfWeek = [
    { value: 'Monday', label: 'Monday' },
    { value: 'Tuesday', label: 'Tuesday' },
    { value: 'Wednesday', label: 'Wednesday' },
    { value: 'Thursday', label: 'Thursday' },
    { value: 'Friday', label: 'Friday' },
    { value: 'Saturday', label: 'Saturday' },
    { value: 'Sunday', label: 'Sunday' },
  ];

  const handleSubmit = async (e) => {

    e.preventDefault();
    setSearchIsLoading(true)
    if (
      formData.retailer_code === "" &&
      formData.store_name === "" &&
      formData.email === "" &&
      formData.abn === "" &&
      formData.state === "" &&
      formData.city === "" &&
      formData.postcode === "" &&
      formData.street_name === ""
    ) {
      toast.error("At least one input field must be filled");
      setSearchIsLoading(false)
      return;
    } else if (formData.street_name && (formData.city === "" && formData.postcode === "")) {
      toast.error("Please enter  post code or city name");
      setSearchIsLoading(false)
      return;
    } else if (formData.state && (formData.city === "" && formData.postcode === "")) {
      toast.error("Please enter street name or post code");
      setSearchIsLoading(false)
      return;
    }
    //console.log("formdata---->", formData);
    const headers = await getApiHeader();
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    try {
      const response = await axios.post(`${SERVER_URL}search-retailer-store`, filteredFormData, {
        headers: headers
      });

      const options = response.data.data.map((value) => ({
        label: value.retailer_company_name,
        // value: value.retailer_code,
        value: value.retailer_id,

      }));

      const updatedStoreOptions = weekDays.map((day, index) => {
        return {
          ...day,
          options: options,
        };
      });


      setStoreOptions(updatedStoreOptions);

      setModalOpen(false)
      setSearchIsLoading(false)

      if (options.length === 0) {
        toast.error("No Shop details Found.");
      } else {
        toast.success("Shop details are populated.");
      }


    } catch (error) {
      console.log("error---------->", error);
    }

  }
  const getWeekOptions = () => {
    const options = [];
    const currentDate = new Date();

    const currentDay = currentDate.getDay();
    const daysUntilMonday = currentDay === 0 ? -6 : 1 - currentDay;
    currentDate.setDate(currentDate.getDate() + daysUntilMonday);

    for (let i = 0; i < 4; i++) {
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() + i * 7);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 4);

      const weekLabel = `${startOfWeek.toLocaleString('default', { month: 'short' })} ${startOfWeek.getDate()} - ${endOfWeek.toLocaleString('default', { month: 'short' })} ${endOfWeek.getDate()}`;
      const weekRange = { start: startOfWeek.toISOString().split('T')[0], end: endOfWeek.toISOString().split('T')[0] };
      options.push(<option key={i} value={JSON.stringify(weekRange)}>{weekLabel}</option>);
    }

    return options;
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="container">
        {setLoad ? (
          <Backdrop
            open={true}
            style={{
              color: '#fff',
              zIndex: 9999,
            }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          <form className="workplanform col-lg-12" onSubmit={(e) => e.preventDefault()}>
            {/* Check if there is any data available */}
            {weekDays?.length > 0 ? (
              <>
                <div className="row align-items-center mb-3">
                  <label htmlFor="plan-details" className="label col-12">
                    {location.state ? "Edit Work Plan Details:" : "Add Work Plan Details:"}
                  </label>
                  {weekDays.map((day, index) => (
                    <div className="row mb-4" key={index}>
                      {/* Your existing form elements */}
                      <div className="col-md-3">
                        <input
                          className="form-control p-3"
                          value={`${day.date} - ${day.dayName}`}
                          readOnly
                          style={{
                            borderRadius: '5px',
                            padding: '5px',
                          }}
                          aria-label={`${day.dayName} date`}
                        />
                        <input
                          type="hidden"
                          name="work_plan"
                          value={day.work_plan || ''}
                        />
                      </div>

                      <div className="col-md-8">
                        <Select
                          isMulti
                          options={storeOptions[index]?.options || []}
                          value={day.selectedDays}
                          onChange={(selectedOptions) => handleSelectChange(selectedOptions, index)}
                          placeholder="Search and add stores for revisits."
                          className="basic-multi-select select-workplan-place-holder"
                          classNamePrefix="select"
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              borderRadius: '5px',
                              padding: '5px',
                            }),
                            multiValue: (provided) => ({
                              ...provided,
                              backgroundColor: '#c11d6c',
                              color: 'white',
                              padding: '1px',
                            }),
                            multiValueLabel: (provided) => ({
                              ...provided,
                              color: 'white',
                            }),
                          }}
                        />
                      </div>

                      {/* Tooltip and IconButton */}
                      <div className="col-md-1">
                        <Tooltip title="Search details of stores" placement="bottom-end">
                          <IconButton
                            onClick={() => handleModalToggle(index)}
                            aria-label="search"
                            style={{
                              marginLeft: '10px',
                              transition: 'transform 0.2s',
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                          >
                            <SearchIcon
                              sx={{
                                color: '#e20e75',
                                transition: 'transform 0.2s, color 0.2s',
                                '&:hover': {
                                  transform: 'scale(1.2)',
                                  color: '#d50b66',
                                },
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </div>

                      <br />

                      {/* React Quill for Plan */}
                      <div className="col-md-12 mt-3">
                        <ReactQuill
                          value={day.plan || ''}
                          onChange={(value) => handleTextChange(value, index, 'plan')}
                          placeholder="Please provide your planned activities."
                          modules={{
                            toolbar: [
                              [{ 'header': [1, 2, false] }],
                              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                              ['link'],
                              ['clean'],
                            ],
                          }}
                          style={{
                            borderColor: '#e20e75',
                            borderRadius: '5px',
                            height: '150px',
                            marginBottom: '55px',
                          }}
                        />
                      </div>

                      {/* Reporting Manager Comments */}
                      <label htmlFor="plan-details" className="label col-12">
                        Reporting Manager Comments
                      </label>
                      <div className="col-md-12 mt-3">
                        <ReactQuill
                          value={managerComment || ''}
                          onChange={(value) => handleTextChange(value, index, 'manager_comment')}
                          placeholder="Provide your comments."
                          modules={{
                            toolbar: [
                              [{ 'header': [1, 2, false] }],
                              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                              ['link'],
                              ['clean'],
                            ],
                          }}
                          style={{
                            borderColor: '#e20e75',
                            borderRadius: '5px',
                            height: '150px',
                            marginBottom: '55px',
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-success col-lg-4"
                    onClick={() => handleActionClick('approve')}
                  >
                    Approve
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger col-lg-4"
                    onClick={() => handleActionClick('reject')}
                  >
                    Reject
                  </button>
                </div>
              </>
            ) : (
              <div className="alert alert-warning" role="alert">
                No work plan deviation requests found. Please try again later.
              </div>
            )}
            <br />
          </form>


        )}
      </div>

      <Modal open={isModalOpen} onClose={handleModalToggle}>

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            bgcolor: 'background.paper',

          }}
        >

          {/* Close Button */}
          <button
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: 'transparent',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: 'black',
            }}
            onClick={handleModalToggle} // This will close the modal
          >
            &times; {/* This is the "×" symbol */}
          </button>

          {searchISLoading ? (
            <Backdrop
              open={true}
              style={{
                color: '#fff',
                zIndex: 9999,
              }}
            >
              <CircularProgress color="inherit" />
            </Backdrop>


          ) : (
            <form action="" method="" onSubmit={handleSubmit}>
              <div className="formbold-mb-5 formbold-pt-3">
                <label className="formbold-form-label formbold-form-label-2">
                </label>
                <div className="flex flex-wrap formbold--mx-3">
                  <div className="w-full sm:w-half formbold-px-3">
                    <label htmlFor="store_name" className="formbold-form-label">
                      Store Name
                    </label>
                    <div className="formbold-mb-5">
                      <input
                        type="text"
                        name="store_name"
                        id="store_name"
                        placeholder="Enter Store Name"
                        className="form-control"
                        value={formData.store_name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Email  Address
                      </label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Enter Email Address"
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Retailer ID
                      </label>
                      <input
                        type="text"
                        name="retailer_code"
                        id="retailer_code"
                        placeholder="Enter Retailer ID"
                        className="form-control"
                        value={formData.retailer_code}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        ABN
                      </label>
                      <input
                        type="text"
                        name="abn"
                        id="abn"
                        placeholder="Enter ABN"
                        className="form-control"
                        value={formData.abn}
                        onChange={handleChange}
                        maxLength={12}
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        City
                      </label>
                      <input
                        type="text"
                        name="city"
                        id="city"
                        placeholder="Enter City Name"
                        className="form-control"
                        value={formData.city}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Post Code
                      </label>
                      <input
                        type="text"
                        name="postcode"
                        id="postcode"
                        placeholder="Enter Post Code"
                        className="form-control"
                        value={formData.postcode}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Street Name
                      </label>
                      <input
                        type="text"
                        name="street_name"
                        id="street_name"
                        placeholder="Enter Street Name"
                        className="form-control"
                        value={formData.street_name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <label htmlFor="store_name" className="formbold-form-label">
                      State
                    </label>
                    <select
                      className="form-control"
                      name="state"
                      id="state"
                      value={formData.state}
                      onChange={handleChange}
                    >
                      <option value="">Select State</option>
                      <option value="Act">ACT</option>
                      <option value="NSW">NSW</option>
                      <option value="NIT">NIT</option>
                      <option value="QLD">QLD</option>
                      <option value="SA">SA</option>
                      <option value="TAS">TAS</option>
                      <option value="VIC">VIC</option>
                      <option value="WA">WA</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="search-store-buttons">
                <button className="search-store-button" type="submit"><i class="fa fa-search"></i> Search</button>

              </div>
            </form>
          )}
        </Box>
      </Modal>


    </DashboardLayout>
  );
}

export default EditRaiseWorkPlanDeviation;
